import React from 'react';
import ReactDOM from 'react-dom/client';
import thunk from 'redux-thunk';
import App from './App';
import './style/ui.scss'
import { applyMiddleware, combineReducers, legacy_createStore as createStore } from 'redux';
import { Provider } from 'react-redux';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import theme from './style/theme';
import { IndexReducer } from './Component/Home/SubComponent/Main/Index/Reducer/IndexReducer';
import { config } from './config/api';
import { FileReducer } from './Component/Home/SubComponent/Main/File/Reducer/FileReducer';
import { FilterReducer } from './Component/Home/SubComponent/Main/Filter/Reducer/FilterReducer';
import { HomeReducer } from './Component/Home/Reducer/HomeReducer';
import { MoshaveranReducer } from './Component/Home/SubComponent/Main/Moshaveran/Reducer/MoshaveranReducer';
import { BookmarkReducer } from './Component/Home/SubComponent/Main/Bookmark/Reducer/BookmarkReducer';
import { SeenReducer } from './Component/Home/SubComponent/Main/LastSeen/Reducer/SeenReducer';
import { AllMoshaveranReducer } from './Component/Home/SubComponent/Main/AllMoshaveran/Reducer/AllMoshaveranReducer';
import { HeaderReducer } from './Component/Home/SubComponent/Header/Reducer/HeaderReducer';

const reducers = combineReducers({
  home: HomeReducer,
  index: IndexReducer,
  file: FileReducer,
  filter: FilterReducer,
  moshaveran: MoshaveranReducer,
  allMoshaveran: AllMoshaveranReducer,
  bookmark : BookmarkReducer,
  seen : SeenReducer,
  header : HeaderReducer
});

const store = createStore(reducers, applyMiddleware(thunk));
config()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);


root.render(
  <Provider store={store} >
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div dir='rtl'>
        <SnackbarProvider autoHideDuration={3000}>
          <App />
        </SnackbarProvider>

      </div>
    </ThemeProvider>
  </Provider>

);


